import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { isPlanBuildableForCurrentDevice } from "redux/selectors/plan-selectors"
import { SelectPlanPage, BuildPlanPage } from "."

const BuildOrSelectPlanPage = ({ isPlanBuilder }) => {
  return isPlanBuilder ? <BuildPlanPage /> : <SelectPlanPage />
}

BuildOrSelectPlanPage.propTypes = {
  isPlanBuilder: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  isPlanBuilder: isPlanBuildableForCurrentDevice(state)
})

export default connect(mapStateToProps)(BuildOrSelectPlanPage)
